export default __webpack_public_path__ + "static/media/map2.8144796a.png";